import {
  Component,
  OnInit
} from '@angular/core';

import {
  FormBuilder,
  FormGroup
} from '@angular/forms';

import {
  SkyAutocompleteSearchFunction,
  SkyAutocompleteSearchFunctionFilter,
  SkyAutocompleteSearchFunctionResponse,
  SkyAutocompleteSelectionChange
} from '../../core';


export class SkyAutocompleteDemoComponent implements OnInit {
  public reactiveForm: FormGroup;
  public templateDrivenModel: any = {
    favoriteColor: { name: 'Red' }
  };

  public selectedColor: any;
  public colors: any[] = [
    { name: 'Red' },
    { name: 'Blue' },
    { name: 'Green' },
    { name: 'Orange' },
    { name: 'Pink' },
    { name: 'Purple' },
    { name: 'Yellow' },
    { name: 'Brown' },
    { name: 'Turquoise' },
    { name: 'White' },
    { name: 'Black' }
  ];

  public largestOcean: any;
  public oceans: any[] = [
    { title: 'Arctic', id: 1 },
    { title: 'Atlantic', id: 2 },
    { title: 'Indian', id: 3 },
    { title: 'Pacific', id: 4 }
  ];

  public farthestPlanet: any;
  public planets: any[] = [
    { name: 'Mercury', description: 'Mercury is a planet in our solar system.' },
    { name: 'Venus', description: 'Venus is a planet in our solar system.' },
    { name: 'Earth', description: 'Earth is a planet in our solar system.' },
    { name: 'Mars', description: 'Mars is a planet in our solar system.' },
    { name: 'Jupiter', description: 'Jupiter is a planet in our solar system.' },
    { name: 'Saturn', description: 'Saturn is a planet in our solar system.' },
    { name: 'Uranus', description: 'Uranus is a planet in our solar system.' },
    { name: 'Neptune', description: 'Neptune is a planet in our solar system.' }
  ];

  public searchFilters: SkyAutocompleteSearchFunctionFilter[] = [
    (searchText: string, item: any): boolean => {
      return (item.name !== 'Red');
    }
  ];

  constructor(
    private formBuilder: FormBuilder
  ) { }

  public ngOnInit(): void {
    this.createForm();
  }

  public submitTemplateForm(formData: any): void {
    alert('Form submitted with: \n' + JSON.stringify(formData));
  }

  public submitReactiveForm(): void {
    alert('Form submitted with: \n' + JSON.stringify(this.reactiveForm.value));
  }

  public onPlanetSelection(args: SkyAutocompleteSelectionChange): void {
    alert(`You selected ${args.selectedItem.name}`);
  }

  public getOceanSearchFunction(): SkyAutocompleteSearchFunction {
    const searchFunction = (searchText: string, oceans: any[]): SkyAutocompleteSearchFunctionResponse => {
      return new Promise((resolve: Function) => {
        const searchTextLower = searchText.toLowerCase();

        const results = oceans.filter((ocean: any) => {
          const val = ocean.title;
          const isMatch = (val && val.toString().toLowerCase().indexOf(searchTextLower) > -1);
          return isMatch;
        });

        // Simulate an async request.
        setTimeout(() => {
          resolve(results);
        }, 500);
      });
    };

    return searchFunction;
  }

  private createForm(): void {
    this.reactiveForm = this.formBuilder.group({
      favoriteColor: undefined,
      farthestPlanet: {},
      largestOcean: { title: 'Arctic', id: 1 }
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-autocomplete-demo',
  template: `<h2 class="sky-section-heading">
  Reactive form setup
</h2>

<form
  class="autocomplete-demo-form"
  [formGroup]="reactiveForm"
  (ngSubmit)="submitReactiveForm()"
  novalidate>

  <h3 class="sky-subsection-heading">
    Basic
  </h3>

  <p>
    The following field uses the default settings.
  </p>

  <div class="sky-form-group">
    <label
      for="my-autocomplete-reactive-basic"
      class="sky-control-label">
      What is your favorite color?
    </label>

    <sky-autocomplete
      [data]="colors">
      <input
        skyAutocomplete
        id="my-autocomplete-reactive-basic"
        type="text"
        formControlName="favoriteColor">
    </sky-autocomplete>
  </div>

  <h3 class="sky-subsection-heading">
    Advanced
  </h3>

  <div style="margin-bottom:10px;">
    The following field:<br>
    <ul>
      <li>utilizes a custom search result template,</li>
      <li>searches against the name and description properties,</li>
      <li>limits the search results to two (2),</li>
      <li>runs the search if the query is at least three (3) characters long,</li>
      <li>and fires an event when a selection is made.</li>
    </ul>
  </div>

  <div class="sky-form-group">
    <label
      for="my-autocomplete-reactive-advanced"
      class="sky-control-label">
      Which planet is farthest from the sun?
    </label>

    <sky-autocomplete
      [data]="planets"
      [propertiesToSearch]="['name', 'description']"
      [searchResultsLimit]="2"
      [searchResultTemplate]="planetSearchResultTemplate"
      [searchTextMinimumCharacters]="3"
      (selectionChange)="onPlanetSelection($event)">
      <input
        skyAutocomplete
        id="my-autocomplete-reactive-advanced"
        type="text"
        formControlName="farthestPlanet">
    </sky-autocomplete>
  </div>

  <h3 class="sky-subsection-heading">
    Search filters
  </h3>

  <p>
    The following field provides a custom function that filters the data before every search attempt.
  </p>

  <div class="sky-form-group">
    <label
      for="my-autocomplete-reactive-filters"
      class="sky-control-label">
      Pick a color ("Red" is not available).
    </label>

    <sky-autocomplete
      [data]="colors"
      [searchFilters]="searchFilters">
      <input
        skyAutocomplete
        id="my-autocomplete-reactive-filters"
        type="text"
        formControlName="favoriteColor">
    </sky-autocomplete>
  </div>

  <h3 class="sky-subsection-heading">
    Custom search function
  </h3>

  <p>
    The following field has a preselected value and utilizes a custom search function, as well as a custom template for the search results.
  </p>

  <div class="sky-form-group">
    <label
      for="my-autocomplete-reactive-custom"
      class="sky-control-label">
      Which ocean is the largest?
    </label>

    <sky-autocomplete
      [data]="oceans"
      [search]="getOceanSearchFunction()"
      [searchResultTemplate]="oceanSearchResultTemplate"
      [descriptorProperty]="'title'">
      <input
        skyAutocomplete
        id="my-autocomplete-reactive-custom"
        type="text"
        formControlName="largestOcean">
    </sky-autocomplete>
  </div>

  <div class="autocomplete-demo-alert">
    <strong>Form model:</strong>
    <pre>{{ reactiveForm.value | json }}</pre>
  </div>

  <button
    class="sky-btn sky-btn-default"
    type="submit">
    Submit
  </button>
</form>

<h2 class="sky-section-heading">
  Template-driven form setup
</h2>

<form
  class="autocomplete-demo-form"
  #myForm="ngForm"
  (ngSubmit)="submitTemplateForm(myForm.value)"
  novalidate>

  <p>
    This field uses the default settings and has a preselected value.
  </p>

  <div class="sky-form-group">
    <label
      for="my-autocomplete-template-driven"
      class="sky-control-label">
      What is your favorite color?
    </label>

    <sky-autocomplete
      [data]="colors">
      <input
        skyAutocomplete
        id="my-autocomplete-template-driven"
        type="text"
        name="favoriteColor"
        [(ngModel)]="templateDrivenModel.favoriteColor">
    </sky-autocomplete>
  </div>

  <div class="autocomplete-demo-alert">
    <strong>Form model:</strong>
    <pre>{{ myForm.value | json }}</pre>
  </div>

  <button
    class="sky-btn sky-btn-default"
    type="submit">
    Submit
  </button>
</form>

<!-- Custom search result templates -->

<ng-template
  let-item="item"
  #planetSearchResultTemplate>
  <strong>{{ item.name }}</strong><br>
  {{ item.description }}
</ng-template>

<ng-template
  let-item="item"
  #oceanSearchResultTemplate>
  <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
  {{ item.title }} &bull; ID {{ item.id }}
</ng-template>
`,
  styles: [`.autocomplete-demo-form ::ng-deep .sky-form-group {
  background-color: #eeeeef;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  margin: 10px 0;
  padding: 10px;
}

.autocomplete-demo-form ::ng-deep h3 {
  margin-top: 30px;
}

.autocomplete-demo-alert {
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #cdcfd2;
  border-radius: 3px;
}

.autocomplete-demo-alert pre {
  margin: 0;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FormBuilder, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
